import Vue from "vue";
import Router from "vue-router";
import home from "../pages/home/home";
import LoginIndex from "../pages/login/loginIndex";
//用户系统
const user = resolve => require(["../pages/user/user.vue"], resolve);
const userBind = resolve => require(["../pages/user/userBind"], resolve);
const userCallback = resolve =>
    require(["../pages/user/userCallback"], resolve);
const userLogin = resolve => require(["../pages/user/userLogin"], resolve);
const userError = resolve => require(["../pages/user/userError"], resolve);
const userRegister = resolve =>
    require(["../pages/user/userRegister"], resolve);
const userNikename = resolve =>
    require(["../pages/user/userNikename"], resolve);

//评估模块
const testUserList = resolve =>
    require(["../pages/test/testUserList"], resolve);
const testUserBack = resolve =>
    require(["../pages/test/testUserBack"], resolve);
const testBack = resolve => require(["../pages/test/testBack"], resolve);
const testWxsao = resolve => require(["../pages/test/wxsao"], resolve);
const testSearch = resolve => require(["../pages/test/testSearch"], resolve);
const testWxInfo = resolve => require(["../pages/test/wxInfo"], resolve);
const userNews = resolve => require(["../pages/test/userNews"], resolve); //个人信息
const myReList = resolve => require(["../pages/test/myReportList"], resolve);
const userReList = resolve =>
    require(["../pages/test/userReportList"], resolve);
const testHome = resolve => require(["../pages/test/testHome"], resolve); //评估提示页面（新版）
const testTipImg = resolve => require(["../pages/test/testTipImg"], resolve);
const testTransition = resolve => require(["../pages/test/testTransition"], resolve);
const testQuestion = resolve =>
    require(["../pages/test/testQuestion"], resolve);
const reportDetails = resolve =>
    require(["../pages/report/reportDetails"], resolve);
const reportDetails2 = resolve =>
    require(["../pages/report/reportDetails2"], resolve);
const reportPlan = resolve =>
    require(["../pages/report/reportPlan.vue"], resolve); //报告详细方案
//展业工具
const enHome = resolve => require(["../pages/exhibition/enHome.vue"], resolve);
const enGuide = resolve =>
    require(["../pages/exhibition/enGuide.vue"], resolve);
const healthPoster = resolve =>
    require(["../pages/exhibition/healthPoster.vue"], resolve);
const keepHealth = resolve =>
    require(["../pages/exhibition/keepHealth.vue"], resolve);
const sendPoster = resolve =>
    require(["../pages/exhibition/sendPoster.vue"], resolve);
const scanPoster = resolve =>
    require(["../pages/exhibition/scanPoster.vue"], resolve);
const guideImg = resolve =>
    require(["../pages/exhibition/guideImg.vue"], resolve);
const videoSrc = resolve =>
    require(["../pages/exhibition/videoSrc.vue"], resolve);
const pdf = resolve => require(["../pages/exhibition/pdf.vue"], resolve);
const discountDetail = resolve =>
    require(["../pages/exhibition/discountDetail.vue"], resolve);
const discount = resolve =>
    require(["../pages/exhibition/discount.vue"], resolve);
const discountBack = resolve =>
    require(["../pages/exhibition/discountBack.vue"], resolve);
//健康排名
const healthRank = resolve =>
    require(["../pages/healthrank/ranking.vue"], resolve);
const rankRule = resolve =>
    require(["../pages/healthrank/rankRule.vue"], resolve);
//文章
const article = resolve => require(["../pages/text/article.vue"], resolve);
const reply = resolve => require(["../pages/text/Reply.vue"], resolve);
const content = resolve => require(["../pages/text/content.vue"], resolve);
//充值卡
const cardHome = resolve => require(["../pages/precard/cardHome.vue"], resolve);
const exCard = resolve => require(["../pages/precard/exCard.vue"], resolve);
const myCard = resolve => require(["../pages/precard/myCard.vue"], resolve);
const sendCard = resolve => require(["../pages/precard/sendCard.vue"], resolve);
const cardRecord = resolve =>
    require(["../pages/precard/cardRecord.vue"], resolve);
//个人中心
const personal = resolve =>
    require(["../pages/personal/personal.vue"], resolve);
const ps = resolve => require(["../pages/personal/ps.vue"], resolve);
const psEstting = resolve =>
    require(["../pages/personal/setting.vue"], resolve);
const psDetails = resolve =>
    require(["../pages/personal/psDetails.vue"], resolve);
const modifyCompany = resolve =>
    require(["../pages/personal/modifyCompany.vue"], resolve);
//我的邀请
const teamFans = resolve => require(["../pages/teamfans/teamFans"], resolve);
const teamCTC = resolve => require(["../pages/teamfans/teamCTC"], resolve);
//人脉银行卡
const ahBuy = resolve => require(["../pages/ahcard/ahBuy.vue"], resolve);
const ahRecord = resolve => require(["../pages/ahcard/ahRecord.vue"], resolve);
const ahJob = resolve => require(["../pages/ahcard/ahJob.vue"], resolve);
const ahVip = resolve => require(["../pages/ahcard/ahVip.vue"], resolve);
const ahVisit = resolve => require(["../pages/ahcard/ahVisit.vue"], resolve);
const cardah = resolve => require(["../pages/ahcard/cardah.vue"], resolve);
//自主经营卡
const monthCard = resolve => require(["../pages/assemble/monthCard"], resolve); //返利月卡
const cardMonth = resolve => require(["../pages/assemble/cardMonth"], resolve); //返利月卡
const assemRecord = resolve =>
    require(["../pages/assemble/assemRecord"], resolve); //购买记录
const assemRule = resolve => require(["../pages/assemble/assemRule"], resolve); //使用规则
const assemBuy = resolve => require(["../pages/assemble/assemBuy"], resolve); //购买拼团
//山东健康红包
const purchased = resolve =>
    require(["../pages/shandong/purchased.vue"], resolve);
const usePresent = resolve =>
    require(["../pages/shandong/usePresent.vue"], resolve);
const present = resolve => require(["../pages/shandong/present.vue"], resolve);
const presentRecord = resolve =>
    require(["../pages/shandong/presentRecord.vue"], resolve);
const healthGift = resolve =>
    require(["../pages/shandong/healthGift.vue"], resolve);
const shandBack = resolve =>
    require(["../pages/shandong/shandBack.vue"], resolve);
//客服
const helpPhone = resolve => require(["../pages/kefu/helpPhone.vue"], resolve);
const shopBack = resolve => require(["../components/shopBack.vue"], resolve);
//公司介绍
const companyInt = resolve =>
    require(["../pages/quanmai/companycp.vue"], resolve);
const exhibition = resolve =>
    require(["../pages/quanmai/exhibition.vue"], resolve);
const policy = resolve => require(["../pages/quanmai/policy.vue"], resolve);
const quanmai = resolve => require(["../pages/quanmai/quanmai.vue"], resolve);
//缺省页
const making = resolve => require(["../components/making.vue"], resolve);
//帮助予反馈
const feedBack = resolve => require(["../pages/helpfeed/feedback"], resolve); //帮助与反馈
const helpFeed = resolve => require(["../pages/helpfeed/helpfeed"], resolve); //意见与反馈
const feedQuestion = resolve =>
    require(["../pages/helpfeed/feedquestion"], resolve); //帮助问题
//健康档案
const myArchive = resolve =>
    require(["../pages/archive/myArchive.vue"], resolve);
const uploadReport = resolve =>
    require(["../pages/archive/uploadReport"], resolve);
const addReport = resolve => require(["../pages/archive/addReport"], resolve);
const archiveChart = resolve =>
    require(["../pages/archive/archiveChart.vue"], resolve);
const chartDetails = resolve =>
    require(["../pages/archive/chartDetails.vue"], resolve);
const erwm = resolve =>
    require(["../pages/test/erwm.vue"], resolve);
//充值送茶饮
const Activity = resolve =>
    require(["../pages/activity/activity.vue"], resolve);
const ActivityRule = resolve =>
    require(["../pages/activity/activityRule.vue"], resolve);
const ActivityBack = resolve =>
    require(["../pages/activity/activityBack.vue"], resolve);
const MyGift = resolve => require(["../pages/activity/myGift.vue"], resolve);
const Accomplish = resolve =>
    require(["../pages/activity/accomplish.vue"], resolve);
const Address = resolve => require(["../pages/activity/address.vue"], resolve);
//分享得优惠
const shareCoupon = resolve =>
    require(["../pages/coupon/shareCoupon.vue"], resolve);
const getCoupon = resolve =>
    require(["../pages/coupon/getCoupon.vue"], resolve);
const shareRule = resolve =>
    require(["../pages/coupon/shareRule.vue"], resolve);
const couponBack = resolve =>
    require(["../pages/coupon/couponBack.vue"], resolve);
const payCoupon = resolve =>
    require(["../pages/coupon/paycoupon.vue"], resolve);
const myCoupon = resolve => require(["../pages/coupon/myCoupon.vue"], resolve);
const couponRecord = resolve =>
    require(["../pages/coupon/couponRecord.vue"], resolve);
//签到积分
const myJifen = resolve => require(["../pages/jifen/myJifen.vue"], resolve);
const jfRule = resolve => require(["../pages/jifen/jfrule.vue"], resolve);
const jobCenter = resolve => require(["../pages/jifen/jobcenter.vue"], resolve);
//健康报告
// const newReport = resolve =>
//     require(["../pages/newreport/newReport.vue"], resolve);
// const newReportPlan = resolve =>
//     require(["../pages/newreport/newReportPlan.vue"], resolve);
const Report = resolve =>
    require(["../pages/newreport/report.vue"], resolve);
//支付
const pay = resolve => require(["../pages/pay/payMethods"], resolve); //支付页面
const payBack = resolve => require(["../pages/pay/payBack.vue"], resolve);
const payWeixin = resolve => require(["../pages/pay/payWeixin"], resolve); //微信支付完成
const paid = resolve => require(["../pages/pay/payComplete"], resolve); //微信和其他支付完成
//会员权益
const myVip = resolve => require(["../pages/vipright/myVip.vue"], resolve);
const vipRecord = resolve =>
    require(["../pages/vipright/vipRecord.vue"], resolve);
const monthVip = resolve =>
    require(["../pages/vipright/monthVip.vue"], resolve);
const vipBack = resolve => require(["../pages/vipright/vipBack.vue"], resolve);
const yzlhealthRed = resolve =>
    require(["../pages/shandong/YzlHealthRed.vue"], resolve);
const aihealthRed = resolve =>
    require(["../pages/shandong/AiHealthRed.vue"], resolve);
//健康红包介绍
const redUser = resolve => require(["../pages/redIntro/redUser.vue"], resolve);
const redManager = resolve =>
    require(["../pages/redIntro/redManager.vue"], resolve);
const redAiUser = resolve =>
    require(["../pages/redIntro/aiRedUser.vue"], resolve);
const redAiManager = resolve =>
    require(["../pages/redIntro/aiRedManager.vue"], resolve);
const redQuanmai = resolve =>
    require(["../pages/redIntro/redQuanmai.vue"], resolve);
const redIntroduce = resolve =>
    require(["../pages/redIntro/redIntroduce.vue"], resolve);
//使用与代理
const module = resolve => require(["../pages/experience/module.vue"], resolve);
const agent = resolve => require(["../pages/experience/agent.vue"], resolve);
const apply = resolve => require(["../pages/experience/apply.vue"], resolve);
const applyOver = resolve =>
    require(["../pages/experience/applyOver.vue"], resolve);
const authCode = resolve =>
    require(["../pages/experience/authCode.vue"], resolve);
//动态提醒
const trends = resolve => require(["../pages/trends/trends.vue"], resolve);
const alldetails = resolve =>
    require(["../pages/trends/alldetails.vue"], resolve);

Vue.use(Router);
const router = new Router({
    mode: "history",
    base: "/",
    routes: [{
            path: "/",
            redirect: "/home"
        },
        {
            path: "/user",
            component: user,
            meta: {
                title: "登录",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/user/login",
            component: userLogin,
            meta: {
                title: "用户登录",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/user/callback",
            component: userCallback,
            meta: {
                title: "登录回调",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/user/bind",
            component: userBind,
            meta: {
                title: "用户绑定",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/user/register",
            component: userRegister,
            meta: {
                title: "用户注册",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },

        {
            path: "/user/error",
            component: userError,
            meta: {
                title: "账户锁定",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/user/nikename",
            component: userNikename,
            meta: {
                title: "用户昵称",
                requireAuth: true // 添加该字段，表示进入这个路由是不需要登录的
            }
        },
        {
            path: "/home",
            component: home,
            meta: {
                title: "首页"
            }
        },
        {
            path: "/test/userList",
            component: testUserList,
            meta: {
                title: "用户列表"
            }
        },
        {
            path: "/test/userBack",
            component: testUserBack,
            meta: {
                title: "用户"
            }
        },
        {
            path: "/test/erwm",
            component: erwm,
            meta: {
                title: "关注公众号"
            }
        },
        {
            path: "/test/userReList",
            component: userReList,
            meta: {
                title: "用户报告列表"
            }
        },
        {
            path: "/login/index",
            component: LoginIndex,
            meta: {
                title: ""
            }
        },
        {
            path: "/test/userBack",
            component: testUserBack,
            meta: {
                title: "用户"
            }
        },
        {
            path: "/test/search",
            component: testSearch,
            meta: {
                title: "用户搜索"
            }
        },
        {
            path: "/test/wxsao",
            component: testWxsao,
            meta: {
                title: "添加用户"
            }
        },
        {
            path: "/test/wxinfo",
            component: testWxInfo,
            meta: {
                title: "用户扫码完善信息"
            }
        },
        {
            path: "/test/myrelist",
            component: myReList,
            meta: {
                title: "报告列表"
            }
        },
        {
            path: "/test/userNews",
            component: userNews,
            meta: {
                title: "用户信息"
            }
        },
        {
            path: "/test/home",
            component: testHome,
            meta: {
                title: "评估首页"
            }
        },
        {
            path: "/test/tipimg/:type",
            component: testTipImg,
            meta: {
                title: "用户评估"
            }
        },
        {
            path: "/test/tiptongue/:type",
            component: testTipImg,
            meta: {
                title: "用户评估"
            }
        },
        {
            path: "/test/transtion",
            component: testTransition,
            meta: {
                title: "用户评估"
            }
        },
        {
            path: "/test/question",
            component: testQuestion,
            meta: {
                title: "问诊"
            }
        },
        //报告
        {
            path: "/test/reportDetails",
            component: reportDetails,
            meta: {
                title: "报告"
            }
        },
        {
            path: "/test/reportDetails2",
            component: reportDetails2,
            meta: {
                title: "报告详情"
            }
        },
        {
            path: "/test/reportPlan",
            component: reportPlan,
            meta: {
                title: "报告详情"
            }
        },
        {
            path: "/test/back",
            component: testBack,
            meta: {
                title: "用户列表"
            }
        },
        //健康报告
        {
            path: "/new/myReport",
            //component: newReport,
            component: Report,
            meta: {
                title: "健康报告"
            }
        },
        // {
        //     path: "/new/report",
        //     component: Report,
        //     meta: {
        //         title: "新版健康报告"
        //     }
        // },
        {
            path: "/new/otherReport",
            //component: newReportPlan,
            component: Report,
            meta: {
                title: "他人报告"
            }
        },
        //健康排名
        {
            path: "/health/rank",
            component: healthRank,
            meta: {
                title: "健康排名"
            }
        },
        {
            path: "/rank/rule",
            component: rankRule,
            meta: {
                title: "健康排名规则"
            }
        },
        //文章
        {
            path: "/text/article",
            component: article,
            meta: {
                title: "健康知识"
            }
        },
        {
            path: "/text/content/:Id",
            component: content,
            meta: {
                title: "文章"
            }
        },
        {
            path: "/text/reply",
            component: reply,
            meta: {
                title: "文章"
            }
        },
        //充值卡
        {
            path: "/pay/list",
            component: cardHome,
            meta: {
                title: "充值卡"
            }
        },
        {
            path: "/pay/weixin",
            component: payWeixin,
            meta: {
                title: "支付完成"
            }
        },
        {
            path: "/card/exchange",
            component: exCard,
            meta: {
                title: "兑换充值码"
            }
        },
        {
            path: "/card/record",
            component: cardRecord,
            meta: {
                title: "卡的使用记录"
            }
        },
        {
            path: "/consult/mycard",
            component: myCard,
            meta: {
                title: "我的卡包"
            }
        },
        {
            path: "/send/card",
            component: sendCard,
            meta: {
                title: "赠送卡包"
            }
        },
        //我的团队规则
        {
            path: "/team/fans",
            component: teamFans,
            meta: {
                title: "粉丝规则"
            }
        },
        //我的团队规则,coc
        {
            path: "/team/ctc",
            component: teamCTC,
            meta: {
                title: "C2C规则"
            }
        },
        //个人中心
        {
            path: "/personal",
            component: personal,
            meta: {
                title: "个人中心"
            }
        },
        {
            path: "/ps",
            component: ps,
            meta: {
                title: "个人中心"
            }
        },
        {
            path: "/personal/details",
            component: psDetails,
            meta: {
                title: "个人中心"
            }
        },
        {
            path: "/personal/setting",
            component: psEstting,
            meta: {
                title: "个人设置"
            }
        },
        //人脉银行
        {
            path: "/ah/buy",
            component: ahBuy,
            meta: {
                title: "人脉卡"
            }
        },
        {
            path: "/ah/record", //拼团
            component: ahRecord,
            meta: {
                title: "人脉卡"
            }
        },
        {
            path: "/ah/job", //拼团
            component: ahJob,
            meta: {
                title: "人脉卡"
            }
        },
        {
            path: "/card/ah", //拼团
            component: cardah,
            meta: {
                title: "人脉卡"
            }
        },
        //自主经营卡
        {
            path: "/assemble/buy", //拼团
            component: assemBuy,
            meta: {
                title: "购买返利月卡"
            }
        },
        {
            path: "/assemble/rule", //规则
            component: assemRule,
            meta: {
                title: "拼团规则"
            }
        },
        {
            path: "/assemble/cardmonth", //分享加入拼团
            component: cardMonth
        },
        {
            path: "/assemble/monthcard", //返利月卡n
            component: monthCard,
            meta: {
                title: "返利月卡任务"
            }
        },
        {
            path: "/assemble/record", //拼团
            component: assemRecord,
            meta: {
                title: "拼团记录"
            }
        },
        //客服
        {
            path: "/help/phone",
            component: helpPhone,
            meta: {
                title: "客服电话"
            }
        },
        //健康档案
        {
            path: "/my/archive",
            component: myArchive,
            meta: {
                title: "健康档案"
            }
        },
        // 健康档案  添加、查看评估报告 type1 报告 2 化验单 status 1-上传  2-查看
        {
            path: "/archive/add/:type/:status",
            component: addReport,
            meta: {
                title: "健康档案报告"
            }
        },
        // 健康档案  上传的评估报告 type 1-报告  2-化验单
        {
            path: "/archive/upload/:type",
            component: uploadReport,
            meta: {
                title: "健康档案上传的评估报告"
            }
        },
        {
            path: "/chart/details",
            component: chartDetails,
            meta: {
                title: "报告明细"
            }
        },
        {
            path: "/archive/chart",
            component: archiveChart,
            meta: {
                title: "健康管家"
            }
        },
        //帮助予反馈
        {
            path: "/help/feed",
            component: helpFeed,
            meta: {
                title: "帮助与反馈"
            }
        },
        {
            path: "/feed/back",
            component: feedBack,
            meta: {
                title: "反馈"
            }
        },
        {
            path: "/feed/question",
            component: feedQuestion,
            meta: {
                title: "反馈问题"
            }
        },
        {
            path: "/activity", //拼团
            component: Activity,
            meta: {
                title: "活动"
            }
        },
        {
            path: "/activity/yzl", //拼团
            component: ActivityBack,
            meta: {
                title: "活动"
            }
        },
        {
            path: "/activity/rule",
            component: ActivityRule,
            meta: {
                title: "活动规则"
            }
        },
        {
            path: "/activity/mygift",
            component: MyGift,
            meta: {
                title: "我的领取"
            }
        },
        {
            path: "/activity/accomplish",
            component: Accomplish,
            meta: {
                title: "物流信息"
            }
        },
        {
            path: "/activity/address",
            component: Address,
            meta: {
                title: "地址"
            }
        },
        //健康红包
        {
            path: "/shand/purchased",
            component: purchased,
            meta: {
                title: "已购卡包"
            }
        },
        {
            path: "/shand/present",
            component: present,
            meta: {
                title: "增送"
            }
        },
        {
            path: "/shand/presentrecord",
            component: presentRecord,
            meta: {
                title: "赠送记录"
            }
        },
        {
            path: "/shand/usepresent",
            component: usePresent,
            meta: {
                title: "使用红包"
            }
        },
        {
            path: "/shand/healthgift",
            component: healthGift,
            meta: {
                title: "健康红包"
            }
        },
        {
            path: "/yzl/healthRed",
            component: yzlhealthRed,
            meta: {
                title: "健康红包"
            }
        },
        {
            path: "/ai/healthRed",
            component: aihealthRed,
            meta: {
                title: "健康红包"
            }
        },
        {
            path: "/shand/back",
            component: shandBack,
            meta: {
                title: "健康红包"
            }
        },
        //积分中心
        {
            path: "/my/jifen",
            component: myJifen,
            meta: {
                title: "我的积分"
            }
        },
        {
            path: "/jifen/rule",
            component: jfRule,
            meta: {
                title: "积分规则"
            }
        },
        {
            path: "/jifen/center",
            component: jobCenter,
            meta: {
                title: "任务中心"
            }
        },
        //展业工具
        {
            path: "/exhibition/enhome",
            component: enHome,
            meta: {
                title: "展业专区"
            }
        },
        {
            path: "/exhibition/enguide/:id",
            component: enGuide,
            meta: {
                title: "新手指南"
            }
        },
        {
            path: "/enguide/img/:id",
            component: guideImg,
            meta: {
                title: "图文"
            }
        },
        {
            path: "/video/src",
            component: videoSrc,
            meta: {
                title: "视频"
            }
        },
        {
            path: "/en/pdf",
            name: "pdf",
            component: pdf,
            meta: {
                title: "图文"
            }
        },
        {
            path: "/en/discount",
            component: discount,
            meta: {
                title: "展业优惠"
            }
        },
        {
            path: "/en/discountback",
            component: discountBack,
            meta: {
                title: "展业优惠"
            }
        },
        {
            path: "/discount/detail/:actionId",
            component: discountDetail,
            meta: {
                title: "展业优惠详情"
            }
        },
        {
            path: "/keep/health/:id",
            component: keepHealth,
            meta: {
                title: "养生"
            }
        },
        {
            path: "/health/poster/:id",
            component: healthPoster,
            meta: {
                title: "养生"
            }
        },
        {
            path: "/scan/poster",
            component: scanPoster,
            meta: {
                title: "海报"
            }
        },
        {
            path: "/send/poster",
            component: sendPoster,
            meta: {
                title: "海报"
            }
        },
        //政策
        {
            path: "/policy", //拼团
            component: policy,
            meta: {
                title: "政策"
            }
        },
        //优惠券
        {
            path: "/coupon/back/:couponId",
            component: couponBack,
            meta: {
                title: "优惠回调"
            }
        },
        {
            path: "/pay/coupon",
            component: payCoupon,
            meta: {
                title: "得到优惠"
            }
        },
        {
            path: "/share/coupon",
            component: shareCoupon,
            meta: {
                title: "分享优惠"
            }
        },
        {
            path: "/company/introduce",
            component: companyInt,
            meta: {
                title: "公司介绍"
            }
        },
        {
            path: "/quanmai",
            component: quanmai,
            meta: {
                title: "公司介绍"
            }
        },
        {
            path: "/get/coupon/:couponId",
            component: getCoupon,
            meta: {
                title: "领取优惠"
            }
        },
        {
            path: "/share/rule",
            component: shareRule,
            meta: {
                title: "分享规则"
            }
        },
        {
            path: "/my/coupon",
            component: myCoupon,
            meta: {
                title: "优惠券"
            }
        },
        {
            path: "/coupon/record",
            component: couponRecord,
            meta: {
                title: "记录"
            }
        },
        //支付页面
        {
            path: "/consult/pay/:orderId",
            component: pay,
            meta: {
                title: "支付页面"
            }
        },
        //支付回调
        {
            path: "/pay/back",
            component: payBack,
            meta: {
                title: "支付返回"
            }
        },
        // 支付宝支付完成页面
        {
            path: "/pay/complete",
            component: paid,
            meta: {
                title: "支付完成",
                isShow: true //添加该字段，表示进入这个路由不显示健康排名
            }
        },
        //获客神器
        {
            path: "/exhibition",
            component: exhibition,
            meta: {
                title: "展业"
            }
        },
        //缺省页
        {
            path: "/making",
            component: making,
            meta: {
                title: ""
            }
        },
        {
            path: "/my/vip",
            component: myVip,
            meta: {
                title: "我的会员"
            }
        },
        {
            path: "/ah/vip",
            component: ahVip,
            meta: {
                title: "年卡会员"
            }
        },
        {
            path: "/ah/visit", //拼团
            component: ahVisit,
            meta: {
                title: "客户列表"
            }
        },
        {
            path: "/month/vip",
            component: monthVip,
            meta: {
                title: "月卡会员"
            }
        },
        {
            path: "/vip/back",
            component: vipBack,
            meta: {
                title: "月卡会员"
            }
        },
        {
            path: "/vip/record",
            component: vipRecord,
            meta: {
                title: "会员记录"
            }
        },
        {
            path: "/shop/back",
            component: shopBack,
            meta: {
                title: "礼品回调"
            }
        },
        {
            path: "/red/user",
            component: redUser,
            meta: {
                title: "用户红包介绍"
            }
        },
        {
            path: "/red/manager",
            component: redManager,
            meta: {
                title: "业务员红包介绍"
            }
        },
        {
            path: "/red/aiuser",
            component: redAiUser,
            meta: {
                title: "用户红包介绍"
            }
        },
        {
            path: "/red/aimanager",
            component: redAiManager,
            meta: {
                title: "业务员红包介绍"
            }
        },
        {
            path: "/red/quanmai",
            component: redQuanmai,
            meta: {
                title: "泉脉红包介绍"
            }
        },
        {
            path: "/red/introduce",
            component: redIntroduce,
            meta: {
                title: "泉脉红包介绍"
            }
        },
        {
            path: "/try/agent",
            component: module
        },
        {
            path: "/auth/code",
            component: authCode
        },
        {
            path: "/apply",
            component: apply
        },
        {
            path: "/apply/over",
            component: applyOver
        },
        {
            path: "/agent",
            component: agent
        },
        {
            path: "/trends",
            component: trends
        },
        {
            path: "/trends/alldetails",
            component: alldetails
        },
        {
            path: "/modify/company",
            component: modifyCompany
        }
    ]
});

// router.afterEach(to => {
//   if (gtag) {
//     gtag('config', 'UA-139122490-6', { 'page_path': to.fullPath })
//   }
// })
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js